module.exports = __webpack_public_path__ + "static/user3-c2464174b619c9e737e0479bc1ae0e24.png";